/** Capitalizes the first character of a lowercase enum value for display
 * (e.g. "medium" -> "Medium"). Shared so provider/effort labels render
 * consistently across the composer, new-chat modal, and handoff picker. */
export function sentenceCase(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
